
import './Client.scss';

import {ArrowForward } from '@mui/icons-material';
//import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
//import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Button } from '@mui/material';
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue } from '../../../Components/docsAdministrative/JsObjectStyles';
// import { radiof } from '../../../Components/Auth/RegisterStepOne';
import { NonIcon, OuiIcon } from '../../../data/SVGs';
import useRole from '../../../hooks/useRole';
import useWindowSize from '../../../hooks/useWindowSize';
import SideBarMobile from '../../Expert/CompleterProfile/SideBarMobile';
import DrawSideBar from './SideBarClient';
const ClientStep2 = () => {
    // const { user } = props;
    const navigate = useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const role = useRole();

    const [newCompany,setNewCompany] = useState(true);
    const onSubmit = (data) => {
        console.log(data);
        // props.updateUser(data);
        console.log(newCompany);
        //TODO
        // 1 create API that add admin nouvelleEntreprise to the 1 case [new company]
        // then ask him the rest [think about render things conditionnaly]
        // 2 create the nouvelleEntreprise based client cases [complete collaborateur backend]
        // ! make sure of what will happen with MME Fatima
        // ! I prefere send the response yes ? not in state
        // newCompany = JSON.parse(newCompany)
        navigate(`/${role}/completeProfile/step3`, {
            state: {
                newCompany
            }
        });
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Etape 2'}
                        etapSuivante='Etape 3'
                        number='2'
                    />
                }
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center',padding:device=='desktop'?'0px':'16px',paddingTop: '64px'}}>
                    <motion.div
                        initial={{ x: '-100vw' }}
                        animate={{ x: 0 }}
                        transition={{ stiffness: 150 }}
                    >
                        <div className="GrandBoxStep3">
                            <div style={{display:'flex',flexDirection:'column',gap:'43px'}}>
                                <h3 className='BienvTitle'>
                                    <Trans>
                                        {i18n.t('Etes vous une nouvelle entreprise sur la plateforme ?')}
                                    </Trans>
                                </h3>
                                <div className='NvEnt'>
                                    <div
                                        className={newCompany ? 'Box2' : 'Box1'}
                                        onClick={() => {setNewCompany(true);}}
                                        style={newCompany ? {borderColor : 'rgba(33, 77, 206, 1)'} : {borderColor : '#9D9E9F'}}
                                    >
                                        <input
                                            type="radio"
                                            name="nouvelleEntreprise"
                                            style={{marginLeft:'160px'}}
                                            checked={newCompany==true}
                                            // value={true}
                                            //id="yes"
                                            onChange={() => {
                                                setNewCompany(true);
                                            }}
                                            required
                                        />
                                        <OuiIcon />
                                        <h6
                                            style={{fontFamily: 'Lato',
                                                fontStyle: 'normal',
                                                fontWeight: '600',
                                                fontSize: '20px',
                                                lineHeight: '32px'}}
                                        >{i18n.t('Oui')}</h6>
                                    </div>
                                    <div
                                        // className='Box1'
                                        className={!newCompany ? 'Box2' : 'Box1'}
                                        onClick={() =>{
                                            setNewCompany(false);
                                        // radiof();
                                        }}
                                        style={!newCompany ? {borderColor : 'rgba(33, 77, 206, 1)'} : {borderColor : '#9D9E9F'}}
                                    >
                                        <input
                                            type="radio"
                                            checked={newCompany==false}
                                            // value={false}
                                            style={{marginLeft:'160px'}}
                                            name="nouvelleEntreprise"
                                            //id="no"
                                            onChange={() => {
                                                setNewCompany(false);
                                            }}
                                        />
                                        <NonIcon />
                                        <h6
                                            style={{fontFamily: 'Lato',
                                                fontStyle: 'normal',
                                                fontWeight: '600',
                                                fontSize: '20px',
                                                lineHeight: '32px'}}
                                        >{i18n.t('Non')}</h6>

                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection:device=='desktop'?'row':'column', justifyContent: 'space-between', alignSelf: 'stretch',gap:'8px' }}>
                                <Button
                                    variant="outlined"
                                    style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                                    onClick={() => {
                                        navigate('/client');
                                    }}
                                >
                                    {i18n.t('Remplir plus tard')}
                                </Button>
                                <Button
                                    variant="contained"
                                    style={{...buttonStylesBlue(),...{width:device=='desktop'?'auto':'100%'}}}
                                    startIcon={<ArrowForward />}
                                    onClick={onSubmit}
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </>
    );
};
export default ClientStep2;
{/* <div className='radio-parent'>
                    <div
                        className="radio-item border border-dark rounded"
                        role="button"
                        onClick={() => setNewCompany(true)}
                    >
                        <input
                            type="radio"
                            name="nouvelleEntreprise"
                            value="true"
                            id="yes"
                            // onChange={e => setNewCompany(JSON.parse(e.target.value))}
                            required
                        />
                        <div style={{fontSize: '200px !important'}}>
                            <CheckCircleOutlineRoundedIcon
                                fontSize='300'
                                // sx={{ fontSize: '100 !important'}}
                                sx={{ fontSize: 100 }}
                            />
                        </div>
                        <label
                            className="label-icon option1"
                            htmlFor="expert"
                        >
                            OUI
                        </label>
                    </div>

                    <div
                        className="radio-item border border-dark rounded "
                        role="button"
                        onClick={() => setNewCompany(false)}
                    >
                        <input
                            type="radio"
                            value="client"
                            name="nouvelleEntreprise"
                            id="no"
                            // onChange={e => setNewCompany(JSON.parse(e.target.value))}
                        />
                        <CancelOutlinedIcon
                            sx={{ fontSize: 100 }}
                        />
                        <label
                            className="label-icon option2"
                            htmlFor="client"
                        >NON</label>
                    </div>
                </div>
                </Form> */}

